import { useEffect, useState } from "react";
import useProcessData from "../contexts/useProcessData";

export const useCachedFetch = (url, storageKey, depend) => {
  const [data, setData] = useState({ devices: [], dates: [] });
  const [loading, setLoading] = useState(false);
  const { response } = useProcessData();
  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        // Always fetch fresh data but keep cache structure
        const response = await fetch(url);
        const result = await response.json();

        // Get user device serials from localStorage
        const userDevices = JSON.parse(localStorage.getItem('userDevices')) || [];
        const userDeviceSerials = userDevices.map(device => device[2]); // Serial number is at index 2

        // Filter only the devices that match userDeviceSerials
        const filteredDevices = (result.devices || []).filter(device => userDeviceSerials.includes(device));

        // Set only the filtered devices to state
        setData({
          devices: filteredDevices,
          dates: result.dates || [], // Keep dates unfiltered
        });

        // Update cache with fresh data
        localStorage.setItem(storageKey, JSON.stringify(data));
      } catch (error) {
        console.error(`Error fetching ${storageKey}:`, error);
        // Fallback to cache if available
        const cachedData = localStorage.getItem(storageKey);
        if (cachedData) {
          setData(JSON.parse(cachedData));
        }
      } finally {
        setLoading(false);
      }
    };

    if (url) fetchData();
  }, [response, depend,data,loading]);

  return { data, loading };
};